// extracted by mini-css-extract-plugin
export default {"clear-button":"ClearButton_clear-button__FFWOS"};